<script lang="ts" setup>
    import Multiselect from '@vueform/multiselect'
    import { Validation } from '~/data/Validation'

    const {
        field,
        defaultValue = '',
        showLabel = true,
        fitContent = false,
        modelValue = '',
    } = defineProps<{
        field: Field
        defaultValue?: string
        showLabel?: boolean
        fitContent?: boolean
        modelValue?: string
    }>()

    const model = defineModel()

    const placeholder = computed(() => {
        let placeholder = field.placeholder ?? ''

        if (
            field.validate &&
            field.validate.indexOf(Validation.required) !== -1
        ) {
            if (placeholder === '') {
                placeholder = field.display
            }

            placeholder += ' *'
        }

        return placeholder.toUpperCase()
    })

    const valueHolder = ref()

    const updateSelectWidth = () => {
        if (!valueHolder.value || !valueHolder.value.nextSibling) {
            return
        }

        setTimeout(
            () =>
                (valueHolder.value.nextSibling.style.width = `${valueHolder.value.scrollWidth}px`),
            1,
        )
    }

    if (fitContent) {
        watch(
            () => modelValue,
            () => updateSelectWidth(),
        )

        onMounted(() => {
            new EfficientResizeListener(updateSelectWidth)
        })
    }

    const options =
        field.options?.map((option) => ({
            value: option.key,
            label: option.value,
            image: option.image,
        })) ?? []
</script>

<template>
    <InputFrame
        :field="field"
        :showLabel="showLabel"
        :fitContent="fitContent"
        :modelValue="model"
    >
        <span
            ref="valueHolder"
            class="value-holder invisible absolute"
            aria-hidden="true"
        >
            <span class="multiselect peer">
                <span class="multiselect-wrapper">
                    <span class="multiselect-placeholder">
                        {{ modelValue ? modelValue : placeholder }}
                    </span>

                    <span class="multiselect-caret" aria-hidden="true"></span>
                </span>
            </span>
        </span>

        <Multiselect
            v-model="model"
            :name="field.handle"
            class="peer"
            :placeholder="showLabel ? null : placeholder"
            :options="options"
            :can-clear="false"
            :can-deselect="false"
        >
            <template #option="{ option }">
                <img v-if="option.image" :src="option.image" alt="" />
                <span>{{ option.label }}</span>
            </template>

            <template #singlelabel="{ value }">
                <span class="multiselect-single-label">
                    <img v-if="value.image" :src="value.image" alt="" />
                    <span class="multiselect-single-label-text">
                        {{ value.label }}
                    </span>
                </span>
            </template>
        </Multiselect>
    </InputFrame>
</template>
